import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../mock';

const Logo = () => (
  <Link to="/" className="flex items-center gap-3 group">
    <img src="/dctv-logo.png" alt="DCTV - Diaspora Community Television" className="h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
    <span className="leading-none hidden sm:block">
      <span className="block text-[10px] tracking-[0.22em] text-[#c9a24a] font-semibold">DIASPORA</span>
      <span className="block text-[10px] tracking-[0.22em] text-[#9aa3b2] mt-1">COMMUNITY TV</span>
    </span>
  </Link>
);

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const onScroll = useCallback(() => setScrolled(window.scrollY > 20), []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0e16]/95 backdrop-blur-md border-b border-white/5' : 'bg-transparent'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-[72px]">
          <Logo />
          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((l) => {
              const active = location.pathname === l.to;
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`text-[13.5px] font-medium dctv-link-underline transition-colors ${active ? 'text-[#e8743b]' : 'text-[#cdd2dc] hover:text-white'}`}
                >
                  {l.label}
                </Link>
              );
            })}
          </nav>
          <div className={`hidden lg:block transition-all duration-300 ${scrolled ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-1 pointer-events-none'}`} data-testid="header-pitch-cta">
            <Link to="/pitch" className="dctv-btn-primary inline-flex items-center px-5 py-2.5 rounded-full text-sm font-semibold">
              Pitch your story
            </Link>
          </div>
          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a0e16] border-t border-white/5 px-6 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => {
              const active = location.pathname === l.to;
              return (
                <Link key={l.to} to={l.to} className={`py-2.5 text-[15px] font-medium ${active ? 'text-[#e8743b]' : 'text-[#cdd2dc]'}`}>
                  {l.label}
                </Link>
              );
            })}
            <Link to="/pitch" className="dctv-btn-primary mt-3 inline-flex items-center justify-center px-5 py-3 rounded-full text-sm font-semibold">
              Pitch your story
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
